// extracted by mini-css-extract-plugin
export default {"roomsMsg":"RoomQuantitySelect_roomsMsg__YXP8q"};